import React from 'react'
import { Link } from 'react-router-dom'
import { dateFormatter, timeFormatter } from '../../../../../helpers/dateFormatter';

import "./FixtureTemplateVgLive.css"

function FixtureTemplateVgLive({index, fixture, type}) {


    function fixtureStatusFormatter(status) {

        let statusFormatted;

        if (status === "FT") {
            statusFormatted = <small>FT</small>
        } else if (status === "NS") {
            statusFormatted = <small>{dateFormatted}</small>
        }

        return statusFormatted;

    }

    function fixtureStatusFormatterHTML(status, elapsed) {
        if (status === "FT") {
            return <small>{dateFormatted}</small>
        } else if (status === "NS") {
            return <small>{timeFormatted}</small>
        } else if (status === "PST") {
            return <small>Postp</small>
        } else if (fixture.elapsed && fixture.elapsed > 0 && fixture.elapsed <= 90 && fixture.statusShort !== "FT") {
            return <span className="text-success">{fixture.elapsed + "'"} <i className="fas fa-circle-notch fa-spin"></i></span>
        } else {
            return status
        }
    }

    const date = new Date(fixture.event_date);
        
    const dateFormatted = dateFormatter(date);
    const timeFormatted = timeFormatter(date)

    return (
        <div key={index} className="card">

            <div className="fixture-event">

                <div className={`${fixture.statusShort === "FT" ? "scores scores-ft" : "scores scores-live"}`}>
                    <div className="event-scores">
                        {fixture.goalsHomeTeam}
                    </div>
                    <div className="event-scores">
                        {fixture.goalsAwayTeam}
                    </div>
                </div>

                <div className="teams">
                    <div className="teams-home">
                        <Link to={type === "small" ? `/live-fixtures/single/${fixture.fixture_id}` : `/live-fixtures/${fixture.fixture_id}`}>           
                            <img src={fixture.homeTeam.logo} className="img-fluid teamLogo" /> {fixture.homeTeam.team_name}    
                        </Link> 
                    </div>
                     
                    <div className="teams-away">
                        <Link to={type === "small" ? `/live-fixtures/single/${fixture.fixture_id}` : `/live-fixtures/${fixture.fixture_id}`}>
                            <img src={fixture.awayTeam.logo} className="img-fluid teamLogo" /> {fixture.awayTeam.team_name} 
                        </Link>
                    </div>
                </div>

                <div className="event events-time">
                    <div className="events-time-center">
                        {fixture.elapsed && fixture.elapsed > 0 && fixture.elapsed <= 90 && fixture.statusShort !== "FT" ? 
                        <span className="text-success">{fixture.elapsed + "'"} <i className="fas fa-circle-notch fa-spin"></i></span> 
                        : 
                        dateFormatter(fixture.event_date)}
                    </div>
                </div>
                
                

            </div>
        </div>
    )

}
export default FixtureTemplateVgLive